var Alberta = "Alberta";
var Manitoba = "Manitoba";
var Nunavut = "Nunavut";
var Ontario = "Ontario";
var Quebec = "Québec";
var Saskatchewan = "Saskatchewan";
var Yukon = "Yukon";
var CAStates = {
	Alberta: Alberta,
	"British Columbia": "Colombie-Britannique",
	Manitoba: Manitoba,
	"New Brunswick": "Nouveau-Brunswick",
	"Newfoundland and Labrador": "Terre-Neuve-et-Labrador",
	"Northwest Territories": "Territoires du Nord-Ouest",
	"Nova Scotia": "Nouvelle-Écosse",
	Nunavut: Nunavut,
	Ontario: Ontario,
	"Prince Edward Island": "Île-du-Prince-Édouard",
	Quebec: Quebec,
	Saskatchewan: Saskatchewan,
	Yukon: Yukon
};

export { Alberta, Manitoba, Nunavut, Ontario, Quebec, Saskatchewan, Yukon, CAStates as default };
